
export const GET_TAX_RULES = "GET_TAX_RULES";
export const SET_TAX_RULES = "SET_TAX_RULES";
export const SET_TAX_RULES_LOADING = "SET_TAX_RULES_LOADING";

export const CREATE_TAX_RULE = "CREATE_TAX_RULE";
export const SET_CREATE_TAX_RULE_LOADING = "SET_CREATE_TAX_RULE_LOADING";

export const UPDATE_TAX_RULE = "UPDATE_TAX_RULE";
export const SET_UPDATE_TAX_RULE_LOADING = "SET_UPDATE_TAX_RULE_LOADING";

export const DELETE_TAX_RULE = "DELETE_TAX_RULE";
export const SET_DELETE_TAX_RULE_LOADING = "SET_DELETE_TAX_RULE_LOADING";

export const getTaxRules = (payload) => ({
    type: GET_TAX_RULES,
    payload,
});

export const setTaxRules = (payload) => ({
    type: SET_TAX_RULES,
    payload,
});

export const setTaxRulesLoading = (payload) => ({
    type: SET_TAX_RULES_LOADING,
    payload,
});

export const createTaxRule = (payload) => ({
    type: CREATE_TAX_RULE,
    payload,
});

export const setCreateTaxRuleLoading = (payload) => ({
    type: SET_CREATE_TAX_RULE_LOADING,
    payload,
});

export const updateTaxRule = (payload) => ({
    type: UPDATE_TAX_RULE,
    payload,
});

export const setUpdateTaxRuleLoading = (payload) => ({
    type: SET_UPDATE_TAX_RULE_LOADING,
    payload,
});

export const deleteTaxRule = (payload) => ({
    type: DELETE_TAX_RULE,
    payload,
});

export const setDeleteTaxRuleLoading = (payload) => ({
    type: SET_DELETE_TAX_RULE_LOADING,
    payload,
});
